// Baby Card Component for Doctor Dashboard - Matching Baby App
import React from 'react';
import { Baby } from 'lucide-react';

const DoctorBabyCard = ({ babyDetails, formatDate, calculateAge }) => {
  if (!babyDetails?.baby) return null;
  
  const baby = babyDetails.baby;
  const isMale = baby.gender?.toLowerCase() === 'male' || baby.gender?.toLowerCase() === 'boy';
  const displayGender = isMale ? 'Male' : 'Female';
  
  // Get latest growth record or fallback to baby's height/weight
  const latestGrowth = babyDetails.growth && babyDetails.growth.length > 0 ? babyDetails.growth[0] : null;
  const height = latestGrowth ? latestGrowth.height : baby.height;
  const weight = latestGrowth ? latestGrowth.weight : baby.weight;
  
  // Only show height/weight if they are greater than 0 (handle both string and number)
  const hasValidHeight = height != null && height !== '' && Number(height) > 0;
  const hasValidWeight = weight != null && weight !== '' && Number(weight) > 0;
  
  return (
    <>
      {/* Profile Section with Balloons */}
      <div className={`profile-section ${isMale ? 'male-balloons' : 'female-balloons'}`}>
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-center flex-1">
            <div className="relative profile-avatar">
              <span>{baby.name?.charAt(0).toUpperCase()}</span>
            </div>
            <div className="flex-1 ml-4">
              <h2 className="text-xl font-bold text-gray-900" style={{fontFamily: 'Space Grotesk'}}>
                {baby.name}
              </h2>
              <p className="text-sm text-gray-500">Date of Birth: {baby.date_of_birth}</p>
              <p className="text-gray-600">{calculateAge(baby.date_of_birth)} • {displayGender}</p>
              {(hasValidHeight || hasValidWeight) && (
                <p className="text-sm text-gray-500">
                  {hasValidHeight ? `${height}cm` : ''}{hasValidHeight && hasValidWeight ? ' • ' : ''}{hasValidWeight ? `${weight}kg` : ''}
                </p>
              )}
              {baby.blood_type && (
                <div className="mt-2 inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  <span className="font-semibold">Blood Group: {baby.blood_type}</span>
                </div>
              )}
            </div>
          </div>
          <div className="text-center sm:text-right">
            <div className="text-xl font-bold text-blue-600 bg-blue-50 px-4 py-2 rounded-lg border-2 border-blue-200">
              {baby.short_id || baby.id?.slice(0, 8).toUpperCase()}
            </div>
          </div>
        </div>
      </div>

      {/* Parent Names Card */}
      {(baby.mother_name || baby.father_name) && (
        <div className="px-6 pb-3">
          <div className="bg-white rounded-lg shadow-md p-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {baby.mother_name && (
                <div className="flex items-center gap-2">
                  <p className="text-xs text-gray-500">Mother:</p>
                  <p className="text-base font-semibold text-gray-900">{baby.mother_name}</p>
                </div>
              )}
              {baby.father_name && (
                <div className="flex items-center gap-2">
                  <p className="text-xs text-gray-500">Father:</p>
                  <p className="text-base font-semibold text-gray-900">{baby.father_name}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DoctorBabyCard;